import config from '../../../configs/config';
import {v4 as UUID} from 'uuid';
import storage from 'local-storage';
import appPath from '../../../misc/appPath';

export function getLinkedinURL(state, webappURI) {
    var clientId = config.linkedinAppId;
    var scope = encodeURIComponent(config.linkedinScope);
    var redirectTo = encodeURIComponent(config.linkedinCallback + '?webapp=' + webappURI);
    var base = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&';
    var scope = config.linkedinScope && config.linkedinScope.length ? `&scope=${encodeURIComponent(config.linkedinScope.join(' '))}` : '';
    return `${base}client_id=${clientId}&redirect_uri=${redirectTo}&state=${state}${scope}`;
}

export default function loginViaLinkedin(redirectTo) {
    let state = UUID(),
        url = getLinkedinURL(state, redirectTo || location.origin + appPath('login/linkedin'));
    storage.set('llst', state);
    location.href = url;
}
